import { getApiBaseUrl } from '../utils/apiConfig.js';

// 运行时获取 API URL，确保使用当前域名
const getVnEvisaDownloadApi = () => `${getApiBaseUrl()}/vn-evisa-download`;

/**
 * 创建 E-VISA PDF 下载任务
 * @param {string} url - 越南官网搜索 URL
 * @returns {Promise<{task_id: string, status: string, message: string}>}
 */
export async function createDownloadTask(url) {
  const resp = await fetch(`${getVnEvisaDownloadApi()}/tasks`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
    credentials: 'include',
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '创建下载任务失败');
  }
  return data;
}

/**
 * 获取任务状态
 * @param {string} taskId - 任务 ID
 * @returns {Promise<{task_id: string, status: string, message: string, captcha_image: string|null, pdf_ready: boolean, error: string|null}>}
 */
export async function getDownloadTaskStatus(taskId) {
  const resp = await fetch(`${getVnEvisaDownloadApi()}/tasks/${taskId}`, {
    credentials: 'include',
  });

  if (resp.status === 404) {
    throw new Error('任务不存在');
  }

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '获取任务状态失败');
  }
  return data;
}

/**
 * 提交验证码
 * @param {string} taskId - 任务 ID
 * @param {string} captcha - 验证码
 * @returns {Promise<{task_id: string, status: string, message: string}>}
 */
export async function submitDownloadCaptcha(taskId, captcha) {
  const resp = await fetch(`${getVnEvisaDownloadApi()}/tasks/${taskId}/captcha`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ captcha }),
    credentials: 'include',
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '提交验证码失败');
  }
  return data;
}

/**
 * 获取 PDF 下载 URL
 * @param {string} taskId - 任务 ID
 * @returns {string}
 */
export function getPdfDownloadUrl(taskId) {
  return `${getVnEvisaDownloadApi()}/tasks/${taskId}/pdf`;
}

/**
 * 下载 PDF 文件
 * @param {string} taskId - 任务 ID
 * @returns {Promise<Blob>}
 */
export async function downloadPdf(taskId) {
  const resp = await fetch(`${getVnEvisaDownloadApi()}/tasks/${taskId}/pdf`, {
    credentials: 'include',
  });

  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data?.detail || '下载 PDF 失败');
  }

  return resp.blob();
}
